<template>
  <TableActionBar position="top">
    <div>
      <TheExportMenu :items="exportOptions" />
    </div>
    <div class="flex-1"></div>
    <div style="width:300px;max-width:300px;">
      <SegmentedListDropdown
        :items="compareOptions"
        :selected="compareOptions[0].items[1]"
        label="Compare by"
        position="bottom"
      />
    </div>
  </TableActionBar>
</template>

<script>
import { SegmentedListDropdown, TheExportMenu } from '@listen360/alexandria'

export default {
  name: 'ReportsTableTopActionBar',
  components: {
    SegmentedListDropdown,
    TheExportMenu
  },
  data() {
    return {
      exportOptions: [
        { title: 'PDF', path: '/somepath' },
        { title: 'XLS', path: '/somepath' }
      ],
      compareOptions: [
        {
          title: 'Heirarchy',
          items: [
            { id: 9, name: 'Region' },
            { id: 10, name: 'District' },
            { id: 11, name: 'Franchise' }
          ]
        },
        {
          title: 'Attribute',
          items: [
            { id: 1, name: 'Customer Tenure' },
            { id: 2, name: 'Gender' },
            { id: 3, name: 'Job Type' }
          ]
        }
      ]
    }
  }
}
</script>
